import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import MeetJac from "@/pages/MeetJac";
import Portfolio from "@/pages/Portfolio";
import Investment from "@/pages/Investment";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Experience from "@/pages/Experience";
import Locations from "@/pages/Locations";
import StudioRental from "@/pages/StudioRental";
import ClientLove from "@/pages/ClientLove";
import EditingQueue from "@/pages/EditingQueue";
import ClientGuide from "@/pages/ClientGuide";
import Journal from "@/pages/Journal";
import JournalPost from "@/pages/JournalPost";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1A1B18",
              color: "#F9F8F6",
              border: "1px solid rgba(249,248,246,0.1)",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/meet-jac" element={<MeetJac />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/investment" element={<Investment />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/studio-rental" element={<StudioRental />} />
            <Route path="/client-love" element={<ClientLove />} />
            <Route path="/editing-queue" element={<EditingQueue />} />
            <Route path="/client-guide" element={<ClientGuide />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<JournalPost />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
